module.exports = __webpack_public_path__ + "635543c715cc8abba0ebee91fc7a1830.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-1.png
// module id = 3116
// module chunks = 0